import axiosInstance from "./axiosInstance";

// ── Products ──────────────────────────────────────────────────────────────────

export const getProducts = (params = {}) =>
  axiosInstance.get("/products/", { params });

export const getProduct = (id) => axiosInstance.get(`/products/${id}/`);

export const createProduct = (data) =>
  axiosInstance.post("/products/", data, {
    headers: { "Content-Type": "application/json" },
  });

export const updateProduct = (id, data) =>
  axiosInstance.patch(`/products/${id}/`, data, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteProduct = (id) => axiosInstance.delete(`/products/${id}/`);

// ── Product Stock (✦ جديد — بديل مبسّط لنظام الـ variants) ─────────────────────

export const updateProductStock = (productId, stock) =>
  axiosInstance.patch(`/products/${productId}/stock/`, { stock });

// ── Product Images ─────────────────────────────────────────────────────────────

export const deleteProductImage = (productId, imageId) =>
  axiosInstance.delete(`/products/${productId}/images/${imageId}/`);

export const setPrimaryImage = (productId, imageId) =>
  axiosInstance.patch(`/products/${productId}/images/${imageId}/`);

// ── Categories ────────────────────────────────────────────────────────────────

export const getCategories = (params = {}) =>
  axiosInstance.get("/categories/", { params });

export const getCategory = (id) => axiosInstance.get(`/categories/${id}/`);

export const createCategory = (data) =>
  axiosInstance.post("/categories/", data);

export const updateCategory = (id, data) =>
  axiosInstance.patch(`/categories/${id}/`, data);

export const deleteCategory = (id) =>
  axiosInstance.delete(`/categories/${id}/`);

// ── Price Tiers ───────────────────────────────────────────────────────────────

export const getPriceTiers = (productId) =>
  axiosInstance.get(`/products/${productId}/price-tiers/`);

export const savePriceTiers = (productId, tiers) =>
  axiosInstance.post(`/products/${productId}/price-tiers/`, tiers);

export const deleteProductVideo = (productId, videoId) =>
  axiosInstance.delete(`/products/${productId}/videos/${videoId}/`);